import React from 'react';
import { useState, useEffect, useRef} from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { configData } from "../config";
import SalespersonSidebar from "./SalespersonSidebar";
import Loading from './Loading';
import { Helmet } from 'react-helmet';

const CourseCodeKey = () => {
  
  const app_url = configData.APP_URL;
  const[courseDetails,setCourseDetails] = useState({});
const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
   
    retrieveProducts();
    
  },[]);
 async function retrieveProducts() {
     try {
  const productlistresponse = await fetch(
    app_url+'smwwcommerceproduct/getcoursecodekey',
    {
      method: "GET",

      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  const productlistdata = await productlistresponse.json();
  const productlist = productlistdata.data.result;
  setCourseDetails(productlist);
}catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
}

  return (
      <>
         {isLoading ? (
              <Loading />
            ) : (
        <div id="main">
            <Helmet><title>Course Code Key</title></Helmet>
           <div class="left"></div>
               
               <div class="center left-center">
                    <h1>Course Code Key</h1>
                        <div class="page-view-myorder">
                            <div class="panel panel-default">
                                <div class="panel-body">
                                    <table class="table table-bordered table-striped sticky-enabled tableheader-processed sticky-table">
	                                    <tbody>
		                                    <tr>
			                                    <th>Product</th>
			                                    <th>Code</th>
			
		                                    </tr>
                                            {courseDetails.map((course, index) => (
                                            <tr>
                                                <td><a href={"/admin/smww-commerce/product-edit/"+course['id']}>{course['name']}</a></td>
                                                <td>{course['sku']}</td>
                                            </tr>
                                            ))}
	                                    </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                </div>
                <div class="right">
                    <SalespersonSidebar/>
                </div>
        </div>
        
     )}
    </>
  )
};

export default CourseCodeKey;
